import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SecureTokenService {
  private accessToken: string | null = null;
  private tokenExpiry: number | null = null;

  /**
   * Store access token in memory only (not in localStorage)
   * @param token JWT access token
   * @param expiresIn Token expiration time in seconds
   */
  setAccessToken(token: string, expiresIn: number): void {
    this.accessToken = token;
    // Calculate expiry time with 30-second buffer for network delays
    this.tokenExpiry = Date.now() + ((expiresIn - 30) * 1000);
  }

  /**
   * Get access token from memory
   * Returns null if token is expired or doesn't exist
   */
  getAccessToken(): string | null {
    if (this.tokenExpiry && Date.now() > this.tokenExpiry) {
      this.clearAccessToken();
      return null;
    }
    return this.accessToken;
  }

  /**
   * Clear access token from memory
   */
  clearAccessToken(): void {
    this.accessToken = null;
    this.tokenExpiry = null;
  }

  /**
   * Check if token exists and is still valid
   */
  isTokenValid(): boolean {
    return this.accessToken !== null && 
           this.tokenExpiry !== null && 
           Date.now() < this.tokenExpiry;
  }

  /**
   * Get remaining token lifetime in seconds
   */
  getTokenRemainingTime(): number {
    if (!this.tokenExpiry) return 0;
    const remaining = Math.max(0, Math.floor((this.tokenExpiry - Date.now()) / 1000));
    return remaining;
  }

  /**
   * Check if token will expire soon (within 5 minutes)
   */
  isTokenExpiringSoon(): boolean {
    if (!this.tokenExpiry) return false;
    const fiveMinutes = 5 * 60 * 1000; // 5 minutes in milliseconds
    return (this.tokenExpiry - Date.now()) < fiveMinutes;
  }
}
